import "./TimeInput.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const TimeInput = ({
  placeholder = "HH:MM",
  name = "",
  isRequired = false,
  label = null,
  labelDescription = null,
  isDisabled = false,
  errorMessage = undefined,
  onChange = () => {},
  value = "",
  register = () => {},
  onKeyUp = () => {},
  classNames = "",
  ...props
}) => {
  const [time, setTIme] = useState(value);
  return (
    <div className="time-input">
      {/* label */}
      {label !== null && (
        <>
          <label htmlFor={name} data-testid="label">
            {isRequired && <span className="text-danger">*</span>}
            <span>{label}</span>
          </label>
          {labelDescription ? (
            <span className="d-block gray--text smallest-text-size mb-1">
              {labelDescription}
            </span>
          ) : null}
        </>
      )}

      {/* input section */}
      <input
        data-testid="input"
        className={`${classNames} ${
          errorMessage !== undefined && "error-border"
        }`}
        type="time"
        name={name}
        placeholder={placeholder}
        id={name}
        {...register(name, { required: isRequired })}
        onChange={(e) => {
          setTIme(e.target.value);
          onChange(e);
        }}
        disabled={isDisabled}
        onKeyUp={onKeyUp}
        value={time}
        {...props}
      />

      {/* error message */}
      <p
        className={`error-message text-danger ${
          errorMessage !== undefined ? "show" : ""
        }`}
        data-testid="error-message"
      >
        <FontAwesomeIcon
          icon={["fas", "exclamation-circle"]}
          className="mr-2"
          style={{ fontSize: "13px" }}
        />
        {errorMessage !== undefined && <span>{errorMessage.message}</span>}
      </p>
    </div>
  );
};

export default TimeInput;
